import React, { useState } from 'react'
import { AppBar, Box, Slide, Toolbar, useScrollTrigger } from '@material-ui/core';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import logo from './assets/images/logo_assurglisse_desktop.png'
import Sidebar from './Components/Sidebar';
import Content from './Components/Content';
import {
  BrowserRouter as Router,
} from "react-router-dom";


function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#000000"
    },
  },
});

function App() {

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  return (
    <Router>
      <React.Fragment>
        <ThemeProvider theme={theme}>
          <HideOnScroll>
            <AppBar>
              <Toolbar>
                <img src={logo} height={30} alt="logo" />
                <h4 className="logo-text">API</h4>
              </Toolbar>
            </AppBar>
          </HideOnScroll>
          {/* <Toolbar /> */}
          <Box className="v-container app" display="flex">
            <Box
              className={`column sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}
              style={sidebarCollapsed
                ? { flexBasis: '70px', maxWidth: '70px', minWidth: '70px', flexShrink: 0 }
                : { flexBasis: '300px', maxWidth: '320px', minWidth: '260px', flexShrink: 0 }}
            >
              <Sidebar collapsed={sidebarCollapsed} onToggleCollapsed={() => setSidebarCollapsed((c) => !c)} />
            </Box>
            <Box className={`column content ${sidebarCollapsed ? 'collapsed' : ''}`} flex="1 1 auto">
              <Content />
            </Box>
          </Box>
        </ThemeProvider>
      </React.Fragment>
    </Router>
  );
}

export default App;
